import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import theme from './theme';
import Login from './components/Login';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import Projects from './components/Projects';
import Clients from './components/Clients';
import Bookings from './components/Bookings';
import Financial from './components/Financial';
import Attendance from './components/Attendance';
import Profile from './components/Profile';
import Reports from './components/Reports';
import LandingPage from './components/LandingPage';
import RecordingService from './components/services/RecordingService';
import PhotographyService from './components/services/PhotographyService';
import OutsideRecordingService from './components/services/OutsideRecordingService';
import ServicePackageManager from './components/ServicePackageManager';
import NotFound from './components/NotFound';
import Forbidden from './components/Forbidden';
import ServerError from './components/ServerError';
import FinancialReports from './components/FinancialReports';
import ProjectReports from './components/ProjectReports';
import StudioAnalytics from './components/StudioAnalytics';
import AuditLogs from './components/AuditLogs';
import AuditDashboard from './components/AuditDashboard';
import AlertSettings from './components/AlertSettings';
import LeaveRequests from './components/LeaveRequests';
import MobileAttendance from './components/Staff/MobileAttendance';
import AttendanceDashboard from './components/Admin/AttendanceDashboard';
import AttendanceWrapper from './components/AttendanceWrapper';
import ClientImport from './components/ClientImport';


// Separate component that uses useAuth
function AppRoutes() {
  const { user } = useAuth();

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

if (user && user.roles.includes('staff') && !user.roles.includes('admin') && isMobile) {
    return <MobileAttendance user={user} />;
  }
  
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
      <Route path="/services/recording" element={<RecordingService />} />
      <Route path="/services/photography" element={<PhotographyService />} />
      <Route path="/services/outside-recording" element={<OutsideRecordingService />} />
      
      {/* Protected routes */}
      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/financial" element={<Financial />} />
         {/* <Route path="/attendance" element={<Attendance />} /> */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/studio-analytics" element={<StudioAnalytics />} />
          <Route path="/service-packages" element={<ServicePackageManager />} />
          <Route path="/audit-logs" element={<AuditLogs />} />  
         <Route path="/audit-dashboard" element={<AuditDashboard />} />
         <Route path="/leave-requests" element={<LeaveRequests />} />
         <Route path="/attendance" element={<AttendanceWrapper />} />
	 <Route path="/clients/import" element={<ClientImport />} />
	 <Route path="/alert-settings" element={<AlertSettings />} />  {/* Add here */}      
</Route>
      </Route>
      
      {/* Error pages */}
      <Route path="/403" element={<Forbidden />} />
      <Route path="/500" element={<ServerError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
